/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesListWorkflows } from "../../funcs/workspacesListWorkflows.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$inboundSchema,
};

export const tool$workspacesListWorkflows: ToolDefinition<typeof args> = {
  name: "workspaces_list-workflows",
  description: `List workflows

Retrieves a list of workflows for a given workspace`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesListWorkflows(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
